import type { EmailContactCreatedFromEnum } from '@gql/graphql';
import type { FormikConfig } from 'formik';
import type { HTMLAttributes } from 'react';

export interface PromoNewsletterFormValues {
  email: string;
  marketingEmailConsent: boolean;
  createdFrom: EmailContactCreatedFromEnum;
  firstName?: string;
  lastName?: string;
  phone?: string;
  hasADog?: boolean;
}

export interface PromoNewsletterData {
  form: {
    initialValues: PromoNewsletterFormValues;
    validationSchema: any;
    onSubmit: FormikConfig<PromoNewsletterFormValues>['onSubmit'];
  };
  canSubmit?: boolean;
  hideHasADogField?: boolean;
}

export interface PromoNewsletterProps extends HTMLAttributes<HTMLDivElement>, PromoNewsletterData {}
